
import { Options, Vue } from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import CardRh from "@/components/cards/ManzaCard.vue";
import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
import KDataTable from "@/components/datatable/newdatatable.vue";
import SiteUtils from '@/assets/ts/aplicacao/site';
import { PerfilConfig } from "@/core/config/PerfisConfig";
import QtsSemanalDiaService from "@/service/v1/sigap/QtsSemanalDiaService";
import $ from "jquery";

@Options({
    name: "QtsSemanalDiaIndex",
    components: { CardRh, KDataTable, BotaoSalvar },
})
export default class QtsSemanalDiaIndex extends Vue {

    @Prop() readonly perfis!: any
    @Prop() readonly qtsSemanalId!: any

    public service = new QtsSemanalDiaService();
    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public modal_editar = 'kt_qts_semanal_dia_editar';

    public novaData = '';
    public editId: any = null;
    public editData = '';

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    private fmtData(v: any) {
        if (!v) return '';
        const s = String(v).substring(0, 10);
        const p = s.split('-');
        return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : s;
    }

    created() {
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => ({
                Skip: d.start,
                Take: d.length,
                qtsSemanalId: this.qtsSemanalId,
                search: d.search.value,
            })
        };
        this.config.order = [[1, 'asc']];
        this.config.columns = [
            { data: 'id', name: 'id' },
            { data: 'data', name: 'data' },
        ];
        this.config.columnDefs = [
            { targets: 1, render: (row) => this.fmtData(row) },
        ];
        if (this.hasPermissaoEditar) {
            this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
            this.config.columnDefs.push({
                targets: 2,
                render: (row, type, val) => {
                    let buttom = '';
                    for (const key in val) { buttom = buttom + ' data-' + key + '="' + val[key] + '"'; }
                    let texto = '<button class="btn btn-success btn-sm me-1" btn-editar-dia ' + buttom + ' title="Editar"><i class="fa fa-edit"></i></button>';
                    texto += '<button class="btn btn-pmes-danger btn-sm" btn-excluir-dia ' + buttom + ' title="Excluir"><i class="fa fa-trash"></i></button>';
                    return texto;
                },
            });
        }
    }

    public refresh() {
        setTimeout(() => { this.reloadDatatable = !this.reloadDatatable; }, 300);
    }

    public adicionar() {
        if (this.processando || !this.hasPermissaoEditar) return;
        if (!this.novaData) { SiteUtils.toastErro('Erro!', 'Informe a data.'); return; }
        if (!this.qtsSemanalId) { SiteUtils.toastErro('Erro!', 'QTS Semanal não identificado.'); return; }
        this.processando = true;
        this.service.cadastrar({ qtsSemanalId: this.qtsSemanalId, data: this.novaData })
            .then(response => {
                SiteUtils.toastSucesso('Dia adicionado!', response?.message);
                this.novaData = '';
                this.processando = false;
                this.refresh();
            })
            .catch(error => {
                this.processando = false;
                SiteUtils.toastErro('Erro!', error?.data?.message);
            });
    }

    public tableatualizada() {
        $('[btn-editar-dia]').click((btn) => {
            const d = $(btn.currentTarget).data();
            this.editId = d.id;
            this.editData = d.data ? String(d.data).substring(0, 10) : '';
            (this.$refs.abrirEditar as HTMLElement).click();
        });
        $('[btn-excluir-dia]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.excluir(id);
        });
    }

    public salvarEdicao() {
        if (this.processando || !this.editId) return;
        if (!this.editData) { SiteUtils.toastErro('Erro!', 'Informe a data.'); return; }
        this.processando = true;
        this.service.update(this.editId, { id: this.editId, qtsSemanalId: this.qtsSemanalId, data: this.editData })
            .then(response => {
                SiteUtils.toastSucesso('Dia atualizado!', response?.message);
                this.processando = false;
                $("[data-bs-dismiss='modal']").trigger({ type: "click" });
                this.refresh();
            })
            .catch(error => {
                this.processando = false;
                SiteUtils.toastErro('Erro!', error?.data?.message);
            });
    }

    public excluir(id) {
        SiteUtils.alertConfimacao('Confirma a Exclusão', '',
            () => {
                this.processando = true;
                this.service.excluir(id)
                    .then(() => {
                        SiteUtils.toastSucesso('Exclusão realizada com sucesso!!');
                        this.processando = false;
                        this.refresh();
                    })
                    .catch(error => {
                        this.processando = false;
                        SiteUtils.toastErro('Não foi possível Excluir', error?.data?.message);
                    });
            }
        );
    }
}
